module.exports = __webpack_public_path__ + "img/ikon_sjostjarna.27ae0562.svg";